export const gift = {
    gift_title: 'تطورك',
    gift_points_1 : 'لديك',
    gift_points_2 : 'نقاط',
    gift_find_gift: 'ابحث عن هديتي',
}
